import PropTypes from 'prop-types';
import RCTooltip from 'rc-tooltip';

const Tooltip = ({ title, ...restProps }) => (
  <RCTooltip
    {...restProps}
    overlay={title}
  >
    <span>{restProps.children}</span>
  </RCTooltip>
);

Tooltip.defaultProps = {
  placement: 'top',
  trigger: 'hover',
};

Tooltip.propTypes = {
  children: PropTypes.node.isRequired,
  trigger: PropTypes.oneOf(['hover', 'click']),
  defaultVisible: PropTypes.bool,
  visible: PropTypes.bool,
  placement: PropTypes.oneOf([
    'top',
    'topLeft',
    'topRight',
    'right',
    'rightTop',
    'rightBottom',
    'bottom',
    'bottomLeft',
    'bottomRight',
    'left',
    'leftTop',
    'leftBottom',
  ]),
  onVisibleChange: PropTypes.func,
  afterVisibleChange: PropTypes.func,
  title: PropTypes.oneOfType([PropTypes.node, PropTypes.func]).isRequired,
  // prefixCls: PropTypes.string,
};

export default Tooltip;
